import React from 'react';
import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import {
  AdaptiveScaleText,
  RosettaIcon,
} from './styles';
import rosetta from '../../assets/icons/rosetta.gif';

const RosettaIInfoSection = () => {
  return (
    <Grid item md={8} xs={12}>
      <Card>
        <CardContent>
          <Grid container item spacing={2} xs={12} alignItems='center'>
            <Grid item md={7} xs={12}>
              <AdaptiveScaleText align="center">
                RosettaDB simplifies the process of migrating your schema to any target database. With RosettaDB, you can effortlessly replicate your database across multiple targets, guaranteeing that your data is always accessible wherever you require it.<br />
              </AdaptiveScaleText>
            </Grid>
            <Grid item md={5} xs={12}>
              <RosettaIcon>
                <img src={rosetta} alt='rosetta_logo' />
                <Typography gutterBottom variant='h6' style={ { color:'white', } }>JDBC Driver</Typography>
                <Button variant='contained' color='primary' onClick={() => window.open('https://www.adaptivescale.com/wp-content/uploads/2023/02/jdbc-driver-2.1.9.jar_.zip', '_blank')}>DOWNLOAD DRIVER</Button>
              </RosettaIcon>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export { RosettaIInfoSection, };
